import { Header } from "@/src/components/layout/Header"
import { Footer } from "@/src/components/layout/Footer"
import { useTranslation } from '@/src/i18n/client'

interface SomethingWentWrongProps {
  error?: Error | string | null
  showLayout?: boolean
}

/**
 * Error page component styled consistently with the 404 page
 */
export function SomethingWentWrong({ error, showLayout = true }: SomethingWentWrongProps) {
  const { t } = useTranslation()
  const errorMessage = typeof error === 'string' 
    ? error 
    : error?.message || t('somethingWentWrong.defaultError')

  const content = (
    <main className="grow flex flex-col items-center justify-center text-center px-4">
      <div className="mb-6 text-6xl">⚙️</div>
      <h1 className="text-4xl font-bold mb-4 text-destructive">
        {t('somethingWentWrong.title')}
      </h1>
      <p className="text-lg text-muted-foreground mb-8 max-w-md">
        {errorMessage}
      </p>
      <a 
        href="/" 
        className="px-6 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors font-medium"
      >
        {t('somethingWentWrong.goBackHome')}
      </a>
    </main>
  )

  if (!showLayout) {
    return content
  }

  return (
    <div className="flex flex-col min-h-screen w-full mx-auto px-2 scrollbar-gutter-stable">
      <Header />
      {content}
      <Footer />
    </div>
  )
}
